import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { Dots } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import CurrencyCardIcon from '../utils/currency-card-icon.js';



class PaymentNoticeCreateForm extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;

		this.quote = null;
		this.order = null;
		this.invoice = null;
		
		let title = '';
		let description = '';
		let amount = 0;
		let currency = {symbol: '', ops: {}};
		let signingkey = null;
		let currentcard = null;
		let balance = '';
		
		this.state = {
			title,
			description,
			amount,
			currency,
			signingkey,
			currentcard,
			balance,
			message_text: '',
			vendoraddress: '',
			paymenturl: '',
			processinginfo: 'processing submission',
			processing: false
		};
	}

	
	// post render commit phase
	componentDidUpdate(prevProps, prevState) {
		console.log('PaymentNoticeCreateForm.componentDidUpdate called');
		
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;
		
		// entered a private key
		if (this.state.signingkey != prevState.signingkey) {
			const {currency} = this.state;

			if ( (currency) && (currency.uuid)) {
				let currentcard = null;
				let balance = '';
				
				let currencyuuid = currency.uuid;

				this.app.createCurrencyCard(currencyuuid, this.state.signingkey, {maincard: true})
				.then(card => {
					currentcard = card;

					return mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid)
				})
				.then((pos) => {
					return mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, pos);
				})
				.then((balance) => {
					this.setState({currentcard, balance});
				})
				.catch(err => {
					this.setState({currentcard, balance})
				});
			}
		}
	}

	componentDidMount() {
		console.log('PaymentNoticeCreateForm.componentDidMount called');
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();
		let rootsessionuuid = this.props.rootsessionuuid;
		
		// message translated in user's language
		let message_text = mvcmyquote.t(
			'When you press the button \'Send Notice\', a url will be generated that you will \
			be able to send to your client asking for the payment of your goods or services. \
			If you haven\'t yet provided your private key, you will be asked to enter it \
			so that your paymentnotice is signed. \
			Your paymentnotice will then be registered and be accessible to anyone clicking on \
			the link that has been generated.');
	
		this.setState({message_text});

		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}
	
	async checkNavigationState() {
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;


		let app_nav_state = this.app.getNavigationState();
		let app_nav_target = app_nav_state.target;
		
		// check wallet is unlocked
		let unlocked = await this.app.checkWalletUnlocked()
		.catch(err => {
		});

		if (!unlocked) {
			let params = (app_nav_target ? app_nav_target.params : null);
			this.app.gotoRoute('login', params);
			return;
		}
		else {
			// check it is not the device wallet, because we need a safer wallet
			let isdevicewallet = await this.app.isDeviceWallet();
			
			if (isdevicewallet) {
				await this.app.resetWallet();
				
			   let params = (app_nav_target ? app_nav_target.params : null);
			   this.app.gotoRoute('login', params);
			   return;
			 }
	   }		

		if (app_nav_target && (app_nav_target.route == 'paymentnotice') && (app_nav_target.reached == false)) {
			let params = app_nav_target.params;
			let dataobj = params.dataobject;

			let invoice = dataobj;
			this.invoice = dataobj;

			if (invoice) {
				let amount = invoice.amount;
				let currencyuuid = invoice.currencyuuid;

				// get order
				let order = await mvcmyquote.fetchCurrencyTransaction(rootsessionuuid, walletuuid, currencyuuid, invoice.order);
				this.order = order;
				

				// get quote
				let quote = await mvcmyquote.fetchCurrencyTransaction(rootsessionuuid, walletuuid, currencyuuid, order.quote);
				this.quote = quote;

				let title = quote.title;
				let description = quote.description;

				let currency = {symbol: '', ops: {}};
				let currentcard;
				let balance = '';

				const cur = await mvcmyquote.getCurrencyFromUUID(rootsessionuuid, currencyuuid)
				.catch(err => {});

				if (cur) {
					currency = cur;
				}

				// vendor details
				let vendoraddress = invoice.owner;

				// get currency position
				currentcard = await this.app.openCurrencyCard(currencyuuid)
				.catch(err => {});

				if (currentcard) {

					let pos = await mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid);
			
					if (pos !== undefined)
						balance = await mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, pos);
	
				}
	
			
				this.setState({title, description, amount, currency, vendoraddress, currentcard, balance });
	
				dataobj.viewed = true;
			}
			else {
				this.app.error('no data object for paymentnotice create form')
			}
			
			app_nav_target.reached = true;
		}
	}
	
	// user actions
	async onSubmit() {
		console.log('onSubmit pressed!');
		
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;
		
		let wallet;
		let carduuid;
		let card;

		let order = this.order;
		let invoice = this.invoice;
		
		let { paymenturl, amount, currency, currentcard, signingkey} = this.state;

		this.setState({processing: true});

		try {

			if (!currency || !currency.uuid) {
				this.app.alert('You need to specify a valid currency');
				this.setState({processing: false});
				return;
			}
	
			// get wallet details
			wallet = await mvcmodule.getWalletInfo(rootsessionuuid, walletuuid);
	
			if (currentcard) {
				card = currentcard;
				carduuid = card.uuid;
			}
			else {
				if (signingkey) {
					let currencyuuid = currency.uuid;
		
					card = await this.app.createCurrencyCard(currencyuuid, signingkey, {maincard: true})
					.catch(err => {
						console.log('error in PaymentNoticeCreateForm.onSubmit: ' + err);
					});
	
					if (!card) {
						this.app.alert('could not create card from private key');
						this.setState({processing: false});
						return;
					}
				}
				else {
					this.app.alert('You need to provide your private key for ' + currency.name + ' in paymentnotice to sign your quote');
					this.setState({processing: false});
					return;
				}
		
			}
	
			// payment url
			if (!paymenturl) {
				if (currency.ops.canpay !== true) {
					this.app.alert('you need to enter a url linked to your payment');
					this.setState({processing: false});
					return;
				}
	
				// check we have enough to pay
				let pos = await mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currency.uuid);
				let tokenamount = await mvcmyquote.getCurrencyAmount(rootsessionuuid, currency.uuid, amount);

				let pos_int = await pos.toInteger();
				let tokenamount_int = await tokenamount.toInteger();
	
				if (pos_int < tokenamount_int) {
					this.app.alert('you do not have enough ' + currency.symbol);
					this.setState({processing: false});
					return;
				}
	
				// check card has enough recommended credits to make transactions
				let credits = await mvcmyquote.getCurrencyCardCredits(rootsessionuuid, walletuuid, currency.uuid);
	
				if ((credits.transactionunits < credits.threshold) && (currency.ops.cantopup !== true)) {
					this.app.alert('you don\'t have enough transaction credits to perform this payment');
					this.setState({processing: false});
					return;
				}
	
				// ask for the payment and return of a payment url
				let vendoraddress = invoice.owner;
				paymenturl = await mvcmyquote.payAndReport(rootsessionuuid, walletuuid, vendoraddress, currency.uuid, tokenamount_int)
				.catch(err => {
					console.log('error in PaymentNoticeCreateForm.onSubmit: ' + err);
				});
			}
	
			// we get the pretrade card to save a transaction holding the pament notice info
			let pretradecard = await mvcmyquote.getPretradeCard(rootsessionuuid, walletuuid, carduuid, currency.uuid)
			.catch(err => {
				console.log('error in PaymentNoticeCreateForm.onSubmit: ' + err);
			});
	
			if (!pretradecard) {
				this.app.alert('Could not get a card to register the payment notice');
				this.setState({processing: false});
				return;
			}
	
			// we top-up pretrade card to be sure being able to send a transaction
			const topupinfo = await mvcmodule.topUpCard(rootsessionuuid, walletuuid, pretradecard.uuid)		
			.catch(err => {
				console.log('error in PaymentNoticeCreateForm.onSubmit: ' + err);
			});
	
			if ((!topupinfo) || (!topupinfo.top) ) {
				this.app.alert('Could not top up account to register payment notice. Wait a few seconds and try again.');
				this.setState({processing: false});
				return;
			}
			else {
				let transactioninfo = await mvcmyquote.getSchemeTransactionInfo(rootsessionuuid, pretradecard.schemeuuid);

				if (topupinfo.balance <= (transactioninfo ? transactioninfo.credits_threshold :  1)) {
					this.app.alert('Account has not been topped-up yet. Wait a few seconds and try again.');
					this.setState({processing: false});
					return;
				}
			}
			
			// order owner
			let decryptcard = await mvcmyquote.getWalletDecryptingCard(rootsessionuuid, walletuuid, order.owner);
	
			// decrypt vendor's details for send
			let vendor_address = invoice.owner;
			let vendor_rsa_publickey = invoice.owner_rsa_publickey;
	
			let vendorname_encrypted = invoice.ownername;
			let vendoremail_encrypted = invoice.owneremail;
	
			let vendorname = await mvcmyquote.rsaDecryptString(rootsessionuuid, walletuuid, decryptcard.uuid, vendor_rsa_publickey, vendorname_encrypted)
			.catch(err => {
				console.log('error in PaymentNoticeCreateForm.onSubmit: ' + err);
			});
	
			let vendoremail = await mvcmyquote.rsaDecryptString(rootsessionuuid, walletuuid, decryptcard.uuid, vendor_rsa_publickey, vendoremail_encrypted)
			.catch(err => {
				console.log('error in PaymentNoticeCreateForm.onSubmit: ' + err);
			});
	
	
			// we crypt our details with the vendor's public key
			// using our pretradecard that will provide our owner_rsa_publickey
			let payername = wallet.ownername
			let payeremail = wallet.owneremail;
	
			const payername_encrypted = await mvcmyquote.rsaEncryptString(rootsessionuuid, walletuuid, pretradecard.uuid, vendor_rsa_publickey, payername)
			.catch(err => {
				console.log('error in PaymentNoticeCreateForm.onSubmit: ' + err);
			});
			const payeremail_encrypted = await mvcmyquote.rsaEncryptString(rootsessionuuid, walletuuid, pretradecard.uuid, vendor_rsa_publickey, payeremail)
			.catch(err => {
				console.log('error in PaymentNoticeCreateForm.onSubmit: ' + err);
			});
	
			
			// we crypt the payment url with the vendor's public key
			const paymenturl_encrypted = await mvcmyquote.rsaEncryptString(rootsessionuuid, walletuuid, pretradecard.uuid, vendor_rsa_publickey, paymenturl)
			.catch(err => {
				console.log('error in PaymentNoticeCreateForm.onSubmit: ' + err);
			});
	
	
			// send transaction
			let payer_address = pretradecard.address;
			let payer_rsa_publickey = pretradecard.publickeys['rsa_public_key'];
	
	
			let paymentnotice = {type: 'paymentnotice', invoice: invoice.txhash, currencyuuid: currency.uuid,
						amount, currency: currency.symbol, paymenturl: paymenturl_encrypted,
						owner: payer_address, owner_rsa_publickey: payer_rsa_publickey, ownername: payername_encrypted, owneremail: payeremail_encrypted};
			let assignto = vendor_address;
	
			let txhash = await mvcmyquote.registerTransaction(rootsessionuuid, walletuuid, pretradecard.uuid, paymentnotice, assignto)
			.catch(err => {
				console.log('error in PaymentNoticeCreateForm.onSubmit: ' + err);
			});
	
			if (!txhash) {
				this.app.alert('Could not register the paymentnotice');
				this.setState({processing: false});
				return;
			}
	
			// get share link
			//var paymentnoticeurl = await this.app.getShareLink(txhash, currency.uuid);
	
			// send link by mail
			let sharelinkmessage = {};
				
			sharelinkmessage.to = [];
			sharelinkmessage.to.push(vendoremail);
	
			sharelinkmessage.subject = mvcmyquote.t('paymentnotice') + ' ' + mvcmodule.fitString(txhash, 12);
			
			sharelinkmessage.message = 'This mail contains the payment notice details for payment notice ' + txhash + '.\r\n\r\n';
	
			// link in message
			sharelinkmessage.linkformat = 'plain';
			
			sharelinkmessage.route = '';
			
			sharelinkmessage.params = {};
			
			sharelinkmessage.params.tx = paymentnotice.txhash;
			sharelinkmessage.params.ccy = paymentnotice.currencyuuid;
			
			await this.app.sendShareLink(sharelinkmessage);
			
	
			// go to list view (to let time for the blockchain to commit the transactions)
			let params = {action: 'view', txhash, currencyuuid: currency.uuid};
	
			await this.app.gotoRoute('paymentnotices', params);
	
			this.setState({processing: false});
	
			return true;
		}
		catch(e) {
			console.log('exception in onSubmit: ' + e);
			this.setState({processing: false});
		}


	}

	
	// rendering
	renderPaymentNoticeCreateForm() {
		let { title, description, amount, currency, currentcard, vendoraddress, paymenturl, signingkey, balance, message_text } = this.state;
		
		return (
			<div className="Form">
				<div>
					<FormGroup controlId="title">
						<FormLabel>Quote Title</FormLabel>
						<FormControl
							disabled
							autoFocus
							type="text"
							value={title}
							onChange={e => this.setState({title: e.target.value})}
						/>
					</FormGroup>

					<FormGroup controlId="VendorAddress">
						<FormLabel>Vendor Address {(currency && currency.name ? 'for ' + currency.name : '')}</FormLabel>
						<FormControl
							autoFocus
							type="text"
							value={vendoraddress}
							onChange={e => this.setState({vendoraddress: e.target.value})}
						/>
					</FormGroup>

					{(currency.ops.canpay === true ?
					<></> :
					<FormGroup controlId="paymenturl">
							<FormLabel>Payment url {(currency && currency.name ? 'for ' + currency.name : '')}</FormLabel>
							<FormControl
								autoFocus
								type="text"
								value={(paymenturl ? paymenturl : '')}
								onChange={e => this.setState({paymenturl: e.target.value})}
							/>
					</FormGroup>)}


					<FormGroup className="Proposal" controlId="proposal">
						<span className="ProposalCol">
							<FormLabel>Amount</FormLabel>
							<FormControl 
								disabled
								autoFocus
								type="text"
								value={amount}
								onChange={e => this.setState({amount: e.target.value})}
							/>
						</span>

						<span className="ProposalCol">
							<FormLabel>Currency</FormLabel>
							<InputGroup>
								<FormControl 
									disabled
									autoFocus
									type="text"
									value={currency.symbol}
									onChange={e => this.onChangeCurrency(e)}
								/>
							</InputGroup>
						</span>

					</FormGroup>

					{(currentcard ?
						<FormGroup className="CurrencyCard" controlId="address">
							<span className="CardIconCol">
								<CurrencyCardIcon
									app={this.app}
									currency={currency}
									card={currentcard}
								/>
							</span>
							<span className="CardBalanceCol">
								<FormLabel>Balance</FormLabel>
								<FormControl
									className="CardBalanceCol"
									disabled
									autoFocus
									type="text"
									value={balance}
								/>
							</span>
						</FormGroup> :
						<FormGroup controlId="signingkey">
							<FormLabel>Private key {(currency && currency.name ? 'for ' + currency.name : '')}</FormLabel>
							<FormControl
								autoFocus
								type="text"
								value={(signingkey ? signingkey : '')}
								onChange={e => this.setState({signingkey: e.target.value})}
							/>
						</FormGroup>
					)}
					
					<Button 
					disabled={(currentcard ? false : true)}
					onClick={this.onSubmit.bind(this)} 
					type="submit">
					{(currency.ops.canpay === true ? 'Pay and Send Notice' : 'Send Notice')}
					</Button>

					<div className="TextBox">
					{message_text}
					</div>

				</div>
			</div>
		  );
	}

	render() {
		let {processing} = this.state; 

		if (processing === true) {
			return (
				<div className="Splash">
					<div>{this.state.processinginfo}</div>
					<Dots />
				</div>
			);
		}
		
		return (
			<div className="Container">
				<div className="Title">Create Payment Notice</div>
				{ this.renderPaymentNoticeCreateForm()}
			</div>
		  );
	}
	
}


// propTypes validation
PaymentNoticeCreateForm.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
	currentwalletuuid: PropTypes.string,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {PaymentNoticeCreateForm};
export default connect(mapStateToProps, mapDispatchToProps)(PaymentNoticeCreateForm);

